export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const COMPANY_SUCCESS = 'COMPANY_SUCCESS'
export const LOGO_SUCCESS = 'LOGO_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_LOGOUT = 'USER_LOGOUT'
export const SUBSCRIPTION_COMPLETE = 'SUBSCRIPTION_COMPLETE'
export const SUBSCRIPTION_CANCEL = 'SUBSCRIPTION_CANCEL'
export const CONNECTED_ACCOUNT_INSPECTED = 'CONNECTED_ACCOUNT_INSPECTED'
